module.exports = __webpack_public_path__ + "img/pedidos.1e9e51c2.svg";